export default __webpack_public_path__ + "static/media/ObservatoryTourist_Bg.97a03d2b.svg";